import { Navigate, useLocation } from 'react-router-dom'
import { useDealerAuth } from '../context/DealerAuthContext'

export default function DealerAuthGuard({ children }: { children: React.ReactNode }) {
  const { me, isLoading } = useDealerAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="dealer-page-loader">
        <div className="dealer-spinner" />
      </div>
    )
  }

  if (!me) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
